import { get } from 'lodash';

export default function canView(securable) {
  return get(securable, 'permissions.can_view.authorization', false);
}
